import { connect } from 'react-redux';

import {
  GET_BOOKING_REVIEW_LIST,
  GET_REVIEW_OVERVIEW_OF_BOOKING_REVIEW,
} from 'store/booking-review/actionTypes';
import { GET_PLACE_DETAIL } from 'store/place/actionTypes';

import Review from './Review';

const mapStateToProps = (state) => ({
  isLoadingGetBookingReviewList:
    state.BookingReview.isLoadingGetBookingReviewList,
  isLoadingGetReviewOverviewOfBookingReview:
    state.BookingReview.isLoadingGetReviewOverviewOfBookingReview,
  isLoadingGetPlaceDetail: state.Place.isLoadingGetPlaceDetail,

  setting: state.Setting.setting,
  bookingReviewList: state.BookingReview.bookingReviewList,
  totalBookingReviewList: state.BookingReview.totalBookingReviewList,
  reviewOverviewOfBookingReview:
    state.BookingReview.reviewOverviewOfBookingReview,
  placeDetail: state.Place.placeDetail,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetBookingReviewList: (payload) => dispatch({
    type: GET_BOOKING_REVIEW_LIST,
    payload,
  }),

  actionGetReviewOverviewOfBookingReview: (payload) => dispatch({
    type: GET_REVIEW_OVERVIEW_OF_BOOKING_REVIEW,
    payload,
  }),

  actionGetPlaceDetail: (payload) => dispatch({
    type: GET_PLACE_DETAIL,
    payload,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Review);
